<template>
  <div class="box">
    <div v-if="currentArea" class="row">
      <span class="label">运营时间：</span>
      <span class="value">{{ operationTimeText }}</span>
      <template v-if="showPrice">
        <span class="label price">单人票价：</span>
        <span class="discount-price" v-if="disCountPrice">{{ disCountPrice }}元</span>
        <span class="value" :class="disCountPrice ? 'original' : ''">{{ priceText }}元</span>
      </template>
    </div>
    <div v-if="runExplain" class="row">
      <div class="label">运营说明：</div>
      <div>{{ runExplain }}</div>
    </div>
  </div>
</template>

<script>
import { checkIsCrossDay } from "@/views/home/util";
import { isDongGuan, fenToYuan } from "@/utils";

export default {
  name: "AreaDesc",
  props: {
    currentArea: {
      type: Object,
      default: null,
    },
  },
  computed: {
    cityId() {
      return this.$AppService.getCityId();
    },
    operationTimeText() {
      const { startRunTime, endRunTime } = this.currentArea || {};
      const isCrossDay = checkIsCrossDay(startRunTime, endRunTime);
      return `${startRunTime}-${isCrossDay ? "次日" : ""}${endRunTime}`;
    },
    showPrice() {
      const { priceMode } = this.currentArea || {};
      return !isDongGuan(this.cityId) && priceMode !== 1;
    },
    priceText() {
      const { price } = this.currentArea || {};
      return fenToYuan(price || 0);
    },
    // 单人优惠票价
    disCountPrice () {
      const { priceList } = this.currentArea || {};
      // 是否存在1个人的阶梯价，优惠价
      const disCount = priceList.find(item => item.num === 1)
      console.log('是否存在单人优惠价' + Boolean(disCount))
      return disCount ? fenToYuan(disCount.price) : null
    },
    runExplain() {
      const { runExplain } = this.currentArea || {};
      return runExplain || "";
    },
  },
  data() {
    return {
    };
  },
  methods: {},
};
</script>

<style scoped lang="scss">
.box {
  margin-bottom: 10px;
}
.row {
  display: flex;
  margin-bottom: 4px;
  font-family: PingFangSC, PingFang SC;
  font-size: 12px;
  color: #000000;
  line-height: 17px;
  text-align: left;
  font-style: normal;
}
.label {
  white-space: nowrap;
  font-weight: 400;
}
.value {
  font-weight: 500;
}
.price {
  margin-left: 10px;
}
.discount-price {
  font-weight: 500;
  color: #FE5959;
  margin-right: 4px;
}
.original {
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  text-decoration: line-through;
  font-size: 10px;
}
</style>
